export const mobile = '360px';
